module.exports = __webpack_public_path__ + "media/images/products/longlife/wedding/wedding-ogp-f58c147a094af6e3c34f33abc1890f97.png";